import { render, staticRenderFns } from "./AppManagement.vue?vue&type=template&id=565d7ac3&scoped=true&"
import script from "./AppManagement.vue?vue&type=script&lang=js&"
export * from "./AppManagement.vue?vue&type=script&lang=js&"
import style0 from "./AppManagement.vue?vue&type=style&index=0&id=565d7ac3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565d7ac3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCheckbox,VDataTable,VSelect,VSpacer})
